require.register("collection/controllers/showCtrl", function(exports, require, module){
  $0
  
});

